import React, { ReactNode } from 'react';
import { useRecoilValue } from 'recoil';
import { IconButton } from '@mui/material';
import { Add, DirectionsBoat, DirectionsCar, Download, Warehouse } from '@mui/icons-material';
import { IconWrapper } from 'components/mui/IconWrapper';
import { nonEditableStatuses } from 'config/cars';
import { CarModel } from 'models/StockModel';
import useCarModals from 'modules/cars/hooks/useCarModals';
import useCarPhotos from 'modules/cars/hooks/useCarPhotos';
import auth from 'recoil/atoms/auth';


type AlbumsProps = {
    car: CarModel,
}

const icons: { [k: string]: ReactNode } = {
    'yard_note': <DirectionsCar color="disabled"/>,
    'vessel_note': <DirectionsBoat color="disabled"/>,
    'destination_note': <Warehouse color="disabled"/>,
}

const AlbumButton = React.memo(({car}: AlbumsProps) => {
    const my = useRecoilValue(auth);
    const {openViewPhotosModal, openAddPhotosModal} = useCarModals();
    const {downloadPhotos} = useCarPhotos();
    const main = car.albums.filter(a => a.name.endsWith('_note') && a.count);

    const lumpSums: Record<string, number> = {};
    let totalPhotos = 0;
    main.forEach(a => lumpSums[a.name.substring(0, 4)] = 0);
    car.albums.forEach(a => {
        lumpSums[a.name.substring(0, 4)] += a.count;
        totalPhotos += a.count;
    });

    return (
        <>
            {main.map(a => (
                <IconWrapper key={a.name} onClick={() => openViewPhotosModal(car, a.name)}>
                    {icons[a.name]}

                    <span>{lumpSums[a.name.substring(0, 4)]}</span>
                </IconWrapper>
            ))}
            {main.length < 3 &&
                my.permissions.has('cars update photos') &&
                !nonEditableStatuses.includes(car.status) && (
                    <IconButton
                        onClick={() => openAddPhotosModal(car)}
                        size="small"
                    >
                        <Add fontSize="small"/>
                    </IconButton>
                )}
            {totalPhotos > 0 && (
                <IconButton
                    onClick={() => downloadPhotos(car.id)}
                    size="small"
                >
                    <Download fontSize="small"/>
                </IconButton>
            )}
        </>
    );
});

export default AlbumButton;
